var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('vue-page-transition',[_c('router-view')],1)],1),_c('v-btn',{attrs:{"fab":"","fixed":"","bottom":"","right":""}},[_c('v-icon',[_vm._v("$question")])],1),_c('ConfirmDialog'),_c('Alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }